import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { categoryName, formatDate } from "@/utils/articles";

interface LatestArticlesProps {
  items: Article[];
}

export default function LatestArticles({ items }: LatestArticlesProps) {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 pb-14 md:pb-20">
      <div className="flex items-end justify-between border-b-2 border-primary-500 pb-4 mb-2">
        <div>
          <p className="text-xs tracking-[0.3em] text-secondary-600 mb-2">LATEST</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新文章
          </h2>
        </div>
        <Link
          to="/search"
          className="hidden sm:inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-secondary-700 transition-colors"
        >
          浏览全部
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div>
        {items.map((a, i) => (
          <article
            key={a.id}
            className="group flex gap-4 md:gap-6 py-5 border-b border-background-200"
          >
            <span className="font-heading text-2xl md:text-3xl font-bold text-background-400 w-8 md:w-12 shrink-0 leading-none pt-1">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium">
                  {categoryName(a.category)}
                </span>
                <span className="text-xs text-foreground-400">
                  {formatDate(a.date)} · {a.author}
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug mb-1.5">
                <Link to={`/detail/${a.id}`} className="hover:text-secondary-700 transition-colors">
                  {a.title}
                </Link>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {a.summary}
              </p>
            </div>
            <Link
              to={`/detail/${a.id}`}
              aria-label={`阅读 ${a.title}`}
              className="hidden md:flex self-center w-10 h-10 items-center justify-center rounded-full border border-background-300 text-foreground-500 group-hover:border-secondary-400 group-hover:text-secondary-600 transition-colors shrink-0"
            >
              <i className="ri-arrow-right-up-line text-lg" />
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}